import React, { useState } from 'react';

import { FloatingBubble, Image, List, Tag, Ellipsis, Modal, NumberKeyboard, PasscodeInput, AutoCenter, Divider,Card } from 'antd-mobile'
import { Typography } from 'antd';
import { request } from '@/utils'
import { EyeOutline, ExclamationCircleFill } from 'antd-mobile-icons'
import './index.scss'
// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/c/font_4335219_nhipwl2o8u8.js',
// });


const { Link } = Typography;

const TOKENKEY = 'aef_token'


const Aef = () => {
  const [visible, setVisible] = useState(false)
  const [yzres, setYzres] = useState(false)
  const [dzs, setDz] = useState([])
  const token = JSON.parse(localStorage.getItem(TOKENKEY))
  const goYanzheng = async (e) => {
    setVisible(false)
    const res = await request.post('/v2/a_resqr_aef_yz', { qrdb: token.qn, yzcode: e })
    res.return_code === "success" && setDz(res.qjson.smdb)
    res.return_code === "success" && setYzres(true)
    res.return_code === "error" && Modal.alert({
      header: (
        <ExclamationCircleFill
          style={{
            fontSize: 64,
            color: 'var(--adm-color-warning)',
          }}
        />
      ),
      title: res.msg,
    })


  }
  ///请求 返回json  写入

  return <>

    <Image lazy src='http://d.ddspp.com:30123/v3/1000_1767765309#sc' />

    {/*  */}
    <div className='topb' align="center">
      <div className='topbz' align="center">

        <div className="item" align="center">
          <Image id="home" src="http://d.ddspp.com:30123/v3/1000_1767766349#sc" onClick={() => setVisible(true)} />
          <span>防伪验证</span></div>


        <div className="item" align="center">
          <Link href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUzODQxODM2OA==#wechat_redirect">
            <Image id="next" src="http://d.ddspp.com:30123/v3/1000_1767767781#sc" />
          </Link>
          <span>微信公众号</span>
        </div>

        <div className="item" align="center">
          <Link href="tel:400-6663561">
            <Image id="prev" src="http://d.ddspp.com:30123/v3/1000_1767767804#sc" />
          </Link>
          <span>联系我们</span>
        </div>
      </div>
    </div>


    {/*  */}


    <Modal
      visible={visible}
      title="请输入验证码"
      content={<>
        <PasscodeInput seperated plain keyboard={<NumberKeyboard />} onFill={goYanzheng} style={{ "--border-color": "#5b8c00" }} />
        <Divider />
        <AutoCenter>
          详见产品包装涂层下
        </AutoCenter>
      </>}
      closeOnMaskClick
      onClose={() => setVisible(false)}

    />
    {/* 验证正确s */}


    {yzres && <Modal
      visible={yzres}
      title="查询结果"
      content={<>
      <Card  style={{fontSize:"12px",margin:"10px",color:"#5b8c00",fontWeight:"bolder"}}>该产品非首次查询!首次查询时间{dzs[0].dtime}
        <br></br>查询地址:{dzs[0].dz}</Card>
        
        <Divider />
        {true && dzs.map((ds, s) =>(s>=1  && <Card  style={{borderColor:"#5b8c00",borderStyle:"groove",fontSize:"12px",margin:"10px"}}>第{s+1}次查询时间:{ds.dtime}<br></br>查询地址：{ds.dz}</Card >) )}
      </>}
      closeOnMaskClick
      onClose={() => setYzres(false)}

    />
    }

    {/* 验证正确e */}

    {
      false && <div style={{
        width: '100%',
        height: '39px',
        background: '#02af6f',
        backgroundImage: 'linear-gradient(to right, #135200, #fff)',
        color: '#FFF',
        lineHeight: '39px',
        paddingLeft: '10px'
        // '--border-bottom': '1px #eee solid',
      }}>
        {/* 这里是栏目 */}
      </div>
    }

    <List style={{ '--font-size': '1em', '--padding-left': '10px' }}>
      <List.Item extra={
        <Ellipsis
          className='lrclass'
          defaultExpanded
          direction='end'
          content={token.qn}
          expandText='展开'
          collapseText=''
        />
      } key='a1'> 单元识别码</List.Item>


      <List.Item
        // description
        extra={
          <Ellipsis
            className='lrclass'
            defaultExpanded
            direction='end'
            content={`${window.location}`}
            expandText='展开'
            collapseText=''
          />
        } key='a2'>
        追溯网址
      </List.Item>

      <List.Item extra={<Tag
        color='success'
        fill='outline'
        style={{ '--background-color': '#c8f7c5', '--border-radius': '3px' }}
        key='a5'
      >
        {token.smnum}
      </Tag>}>扫码次数</List.Item>






    </List>






    {true && token.pjson.mjson.map((ea, i) => <>
      <div style={{
        width: '100%',
        height: '39px',
        background: '#02af6f',
        backgroundImage: 'linear-gradient(to right, #135200, #fff)',
        color: '#FFF',
        lineHeight: '39px',
        paddingLeft: '10px'
      }} key={`div${i}`}>{ea.mname}</div>
    
      {true && <List style={{ '--font-size': '1em', '--padding-left': '10px' }}>
        {ea !== undefined && ea.list.map((e, ii) => <List.Item extra={<Ellipsis
          className='lrclass'
          defaultExpanded
          direction='end'
          content={e.second}
          expandText='展开'
          collapseText=''
        />} key={ii}> {e.first}</List.Item>)}




      </List>}


    </>
    )}






    {
      false && <FloatingBubble
        axis='xy'
        magnetic='x'
        style={{
          '--background': 'none',
          '--initial-position-bottom': '24px',
          '--initial-position-right': '24px',
          '--edge-distance': '24px',
        }}
      >
        <EyeOutline fontSize={32} color='#1677ff' />
      </FloatingBubble>
    }



    <div style={{ height: "59px" }}></div>

    <Image src='http://d.ddspp.com:30123/v3/1000_1767767824#sc' className='footer' />


  </>
}

export default Aef;